(function () {
  'use strict';

  /* @ngdoc object
   * @name paymentTemplates
   * @description
   *
   */
  angular
    .module('paymentTemplates', [
      'ui.router'
    ]);
}());
